import '@/installCompositionApi'
import '@/installFineMq'

import { mountComponentTag } from '@/mounter'

import DotcomBreadcrumb from './Breadcrumb'

mountComponentTag('dotcom-breadcrumb', DotcomBreadcrumb)
